// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PaperMoneyDepositAcceptFirstDepositEvent
 */
export var PaperMoneyDepositAcceptFirstDeposit = function (_a) {
    var depositToken = _a.depositToken, amount = _a.amount;
    return ({
        name: "PaperMoney Deposit AcceptFirstDeposit",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            deposit_token: depositToken !== undefined && depositToken !== null ? depositToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositAcceptDepositEvent
 */
export var PaperMoneyDepositAcceptDeposit = function (_a) {
    var depositToken = _a.depositToken, amount = _a.amount;
    return ({
        name: "PaperMoney Deposit AcceptDeposit",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            deposit_token: depositToken !== undefined && depositToken !== null ? depositToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewMapEvent
 */
export var PaperMoneyDepositViewMap = function () { return ({
    name: "PaperMoney Deposit ViewMap",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositViewVisibleNearbyRetailersEvent
 */
export var PaperMoneyDepositViewVisibleNearbyRetailers = function (_a) {
    var visibleRetailers = _a.visibleRetailers;
    return ({
        name: "PaperMoney Deposit ViewVisibleNearbyRetailers",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            visible_retailers: visibleRetailers !== undefined && visibleRetailers !== null ? visibleRetailers.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositGrantLocationPermissionEvent
 */
export var PaperMoneyDepositGrantLocationPermission = function (_a) {
    var androidLocationAuthorizationStatus = _a.androidLocationAuthorizationStatus, iosLocationAuthorizationStatus = _a.iosLocationAuthorizationStatus, iosPreciseLocationEnabled = _a.iosPreciseLocationEnabled;
    return ({
        name: "PaperMoney Deposit GrantLocationPermission",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            android_location_authorization_status: androidLocationAuthorizationStatus !== undefined && androidLocationAuthorizationStatus !== null ? androidLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_location_authorization_status: iosLocationAuthorizationStatus !== undefined && iosLocationAuthorizationStatus !== null ? iosLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_precise_location_enabled: iosPreciseLocationEnabled !== undefined && iosPreciseLocationEnabled !== null ? iosPreciseLocationEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewTutorialEvent
 */
export var PaperMoneyDepositViewTutorial = function () { return ({
    name: "PaperMoney Deposit ViewTutorial",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositCloseTutorialEvent
 */
export var PaperMoneyDepositCloseTutorial = function (_a) {
    var viewedAllContent = _a.viewedAllContent;
    return ({
        name: "PaperMoney Deposit CloseTutorial",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            viewed_all_content: viewedAllContent !== undefined && viewedAllContent !== null ? viewedAllContent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewSwipeToLoadOnboardingEvent
 */
export var PaperMoneyDepositViewSwipeToLoadOnboarding = function () { return ({
    name: "PaperMoney Deposit ViewSwipeToLoadOnboarding",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositSearchAddressEvent
 */
export var PaperMoneyDepositSearchAddress = function () { return ({
    name: "PaperMoney Deposit SearchAddress",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositSelectAddressEvent
 */
export var PaperMoneyDepositSelectAddress = function (_a) {
    var recentAddress = _a.recentAddress;
    return ({
        name: "PaperMoney Deposit SelectAddress",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            recent_address: recentAddress !== undefined && recentAddress !== null ? recentAddress.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewMerchantEvent
 */
export var PaperMoneyDepositViewMerchant = function (_a) {
    var storeToken = _a.storeToken;
    return ({
        name: "PaperMoney Deposit ViewMerchant",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            store_token: storeToken !== undefined && storeToken !== null ? storeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewBarcodeEvent
 */
export var PaperMoneyDepositViewBarcode = function (_a) {
    var depositToken = _a.depositToken, launchLocation = _a.launchLocation;
    return ({
        name: "PaperMoney Deposit ViewBarcode",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            deposit_token: depositToken !== undefined && depositToken !== null ? depositToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            launch_location: launchLocation !== undefined && launchLocation !== null ? launchLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositViewHelpEvent
 */
export var PaperMoneyDepositViewHelp = function (_a) {
    var launchLocation = _a.launchLocation;
    return ({
        name: "PaperMoney Deposit ViewHelp",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "Deposit",
            launch_location: launchLocation !== undefined && launchLocation !== null ? launchLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaperMoneyDepositClickDirectionsEvent
 */
export var PaperMoneyDepositClickDirections = function () { return ({
    name: "PaperMoney Deposit ClickDirections",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositClickFeeStatusEvent
 */
export var PaperMoneyDepositClickFeeStatus = function () { return ({
    name: "PaperMoney Deposit ClickFeeStatus",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyDepositExplainerClickNeedHelpEvent
 */
export var PaperMoneyDepositExplainerClickNeedHelp = function () { return ({
    name: "PaperMoney Deposit ExplainerClickNeedHelp",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see PaperMoneyMapFilterOpenEvent
 */
export var PaperMoneyMapFilterOpen = function () { return ({
    name: "PaperMoney MapFilter Open",
    parameters: {
        cdf_entity: "PaperMoney",
        cdf_action: "MapFilter",
    }
}); };
/**
 * @see PaperMoneyMapFilterApplyEvent
 */
export var PaperMoneyMapFilterApply = function (_a) {
    var isBarcodeSelected = _a.isBarcodeSelected, isSwipeSelected = _a.isSwipeSelected;
    return ({
        name: "PaperMoney MapFilter Apply",
        parameters: {
            cdf_entity: "PaperMoney",
            cdf_action: "MapFilter",
            is_barcode_selected: isBarcodeSelected !== undefined && isBarcodeSelected !== null ? isBarcodeSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_swipe_selected: isSwipeSelected !== undefined && isSwipeSelected !== null ? isSwipeSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
